var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAtivo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2987_4054",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2987_4054)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "#0CBA90",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0912 16C9.98756 16 9.8904 15.985 9.79972 15.9549C9.70904 15.9253 9.62484 15.8747 9.54711 15.8031L6.20481 12.7248C6.06231 12.5936 5.99417 12.4234 6.00039 12.2144C6.00713 12.0058 6.08174 11.8359 6.22425 11.7047C6.36675 11.5735 6.54811 11.5078 6.76834 11.5078C6.98857 11.5078 7.16993 11.5735 7.31243 11.7047L10.0912 14.264L16.6786 8.19687C16.8211 8.06562 17.0059 8 17.2328 8C17.4593 8 17.6437 8.06562 17.7862 8.19687C17.9288 8.32811 18 8.49802 18 8.70658C18 8.91562 17.9288 9.08576 17.7862 9.217L10.6353 15.8031C10.5576 15.8747 10.4734 15.9253 10.3827 15.9549C10.292 15.985 10.1948 16 10.0912 16Z",
    fill: "#0CBA90"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtivo);
export default __webpack_public_path__ + "static/media/Ativo.4e57909c9a73d95426a33f4ff1dcf574.svg";
export { ForwardRef as ReactComponent };